/**
 * Card Media Swiper
 * - Mobile: Swiper.js between first image and second media/image/video
 * - Desktop: Hover to reveal/play second media
 *
 * Important:
 * If .card-media-swiper is inside another Swiper carousel,
 * it is disabled so the outer carousel can handle swiping.
 */

(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 990;
  const SWIPE_THRESHOLD = 8;

  let cardSwipers = [];

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function getAllCardMediaSwipers() {
    return document.querySelectorAll('.card-media-swiper[data-has-second-media="true"]');
  }

  function isInsideAnotherSwiper(el) {
    if (!el || !el.parentElement) return false;

    // Start from parentElement so we do not count the card-media-swiper itself.
    return !!el.parentElement.closest('.swiper, .swiper-container');
  }

  function getStandaloneCardMediaSwipers() {
    return Array.from(getAllCardMediaSwipers()).filter(function (el) {
      return !isInsideAnotherSwiper(el);
    });
  }

  function markNestedCardMediaSwipers() {
    getAllCardMediaSwipers().forEach(function (el) {
      const isNested = isInsideAnotherSwiper(el);

      if (isNested) {
        el.classList.add('card-media-swiper--disabled-nested');

        // If this inner swiper was already initialized, destroy it.
        if (el.swiper && !el.swiper.destroyed) {
          el.swiper.destroy(true, true);
        }
      } else {
        el.classList.remove('card-media-swiper--disabled-nested');
      }
    });

    // Clean up our swiper tracking array.
    cardSwipers = cardSwipers.filter(function (swiper) {
      return swiper && !swiper.destroyed;
    });
  }

  /* =====================
     Swipe click guard
     Prevent accidental product link clicks while swiping
     ===================== */

  function bindSwipeClickGuard(el) {
    if (!el || el.dataset.swipeClickGuard === 'true') return;

    el.dataset.swipeClickGuard = 'true';

    let startX = 0;
    let startY = 0;
    let didSwipe = false;
    let lastSwipeTime = 0;

    el.addEventListener(
      'pointerdown',
      function (event) {
        startX = event.clientX;
        startY = event.clientY;
        didSwipe = false;
      },
      { passive: true }
    );

    el.addEventListener(
      'pointermove',
      function (event) {
        const diffX = Math.abs(event.clientX - startX);
        const diffY = Math.abs(event.clientY - startY);

        if (diffX > SWIPE_THRESHOLD && diffX > diffY) {
          didSwipe = true;
          lastSwipeTime = Date.now();
        }
      },
      { passive: true }
    );

    el.addEventListener(
      'click',
      function (event) {
        const recentSwipe = didSwipe || Date.now() - lastSwipeTime < 250;

        if (!recentSwipe) return;

        const link = event.target.closest('a');

        if (link && el.contains(link)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }



  function bindTapToProduct(el) {
  if (!el || el.dataset.tapToProductBound === 'true') return;

  el.dataset.tapToProductBound = 'true';

  let startX = 0;
  let startY = 0;
  let didSwipe = false;
  let lastSwipeTime = 0;

  el.addEventListener(
    'pointerdown',
    function (event) {
      startX = event.clientX;
      startY = event.clientY;
      didSwipe = false;
    },
    { passive: true }
  );

  el.addEventListener(
    'pointermove',
    function (event) {
      const diffX = Math.abs(event.clientX - startX);
      const diffY = Math.abs(event.clientY - startY);

      if (diffX > 8 && diffX > diffY) {
        didSwipe = true;
        lastSwipeTime = Date.now();
      }
    },
    { passive: true }
  );

  el.addEventListener(
    'click',
    function (event) {
      const recentSwipe = didSwipe || Date.now() - lastSwipeTime < 250;

      if (recentSwipe) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      // Do not hijack dots or real interactive elements
      if (
        event.target.closest('.card-swiper-pagination') ||
        event.target.closest('button') ||
        event.target.closest('input') ||
        event.target.closest('label') ||
        event.target.closest('select') ||
        event.target.closest('textarea') ||
        event.target.closest('form') ||
        event.target.closest('.quick-add') ||
        event.target.closest('quick-add-modal') ||
        event.target.closest('product-form') ||
        event.target.closest('.collection-swatches') ||
        event.target.closest('.collection-sizes')
      ) {
        return;
      }

      const wrapper = el.closest('.card-wrapper');
      if (!wrapper) return;

      const productLink = wrapper.querySelector('.card__heading a[href]');

      if (productLink && productLink.href) {
        window.location.href = productLink.href;
      }
    },
    true
  );
}
  /* =====================
     Mobile: Init standalone card media swipers only
     ===================== */

  function initMobileSwipers() {
    markNestedCardMediaSwipers();

    const swiperEls = getStandaloneCardMediaSwipers();

   swiperEls.forEach(function (el) {
  bindSwipeClickGuard(el);
  bindTapToProduct(el);

  if (el.swiper && !el.swiper.destroyed) return;

      const swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        loop: false,

        // Helpful if this ever ends up near other touch elements.
        nested: true,

        // Prevent accidental anchor clicks while dragging/swiping.
        preventClicks: true,
        preventClicksPropagation: true,
        slideToClickedSlide: false,

        // Swipe feel.
        threshold: SWIPE_THRESHOLD,
        touchAngle: 35,
        touchEventsTarget: 'container',
        touchStartPreventDefault: false,
        passiveListeners: true,
        simulateTouch: true,
        allowTouchMove: true,

        resistance: true,
        resistanceRatio: 0.85,

        pagination: {
          el: el.querySelector('.card-swiper-pagination'),
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active'
        },

        on: {
          slideChangeTransitionEnd: function () {
            handleMobileSlideChange(this);
          }
        }
      });

      cardSwipers.push(swiper);
    });
  }

  function destroyMobileSwipers() {
    cardSwipers.forEach(function (swiper) {
      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }
    });

    cardSwipers = [];
  }

  function handleMobileSlideChange(swiper) {
    if (!swiper || !swiper.slides) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;

    swiper.slides.forEach(function (slide) {
      const video = slide.querySelector('video');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    if (activeVideo) {
      activeVideo.play().catch(function () {
        // Autoplay may be blocked. Poster/image fallback will remain visible.
      });
    }
  }

  /* =====================
     Desktop: Hover second media/video
     ===================== */

  function initDesktopHover() {
    const cards = getAllCardMediaSwipers();

    cards.forEach(function (swiperEl) {
      const wrapper = swiperEl.closest('.card-wrapper');

      if (!wrapper || wrapper.dataset.cardHoverBound === 'true') return;

      const video = swiperEl.querySelector('.swiper-slide:nth-child(2) video');

      if (!video) return;

      wrapper.addEventListener('mouseenter', function () {
        if (isMobile()) return;

        video.currentTime = 0;

        video.play().catch(function () {
          // Ignore autoplay errors.
        });
      });

      wrapper.addEventListener('mouseleave', function () {
        if (isMobile()) return;

        video.pause();
        video.currentTime = 0;
      });

      wrapper.dataset.cardHoverBound = 'true';
    });
  }

  /* =====================
     Responsive handling
     ===================== */

  function handleResponsiveState() {
    markNestedCardMediaSwipers();

    if (isMobile()) {
      initMobileSwipers();
    } else {
      destroyMobileSwipers();
      initDesktopHover();
    }
  }

  function init() {
    markNestedCardMediaSwipers();
    handleResponsiveState();
    initDesktopHover();
  }

  function waitForSwiper(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    let attempts = 0;

    const interval = setInterval(function () {
      attempts++;

      if (typeof Swiper !== 'undefined') {
        clearInterval(interval);
        callback();
      }

      if (attempts > 50) {
        clearInterval(interval);
        console.warn('Card Media Swiper: Swiper.js not found. Mobile swiping disabled.');
        initDesktopHover();
      }
    }, 100);
  }

  /* =====================
     Init
     ===================== */

  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      waitForSwiper(handleResponsiveState);
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(init);
    });
  } else {
    waitForSwiper(init);
  }

  document.addEventListener('shopify:section:load', function () {
    waitForSwiper(init);
  });

  document.addEventListener('shopify:section:reorder', function () {
    waitForSwiper(init);
  });
})();